<template>
  <div class="sales-reports-inline-filter lov-card mb-3">
    <b-row class="align-items-end">
      <b-col
        v-if="showDateRange"
        md="6"
        lg="2"
        class="mb-2"
      >
        <label class="filter-label">Từ ngày</label>
        <date-picker
          v-model="local.startDate"
          :config="dpConfigs.date"
          class="form-control form-control-sm"
        />
      </b-col>
      <b-col
        v-if="showDateRange"
        md="6"
        lg="2"
        class="mb-2"
      >
        <label class="filter-label">Đến ngày</label>
        <date-picker
          v-model="local.endDate"
          :config="dpConfigs.date"
          class="form-control form-control-sm"
        />
      </b-col>

      <b-col
        v-if="showStoreMulti"
        md="6"
        lg="3"
        class="mb-2"
      >
        <label class="filter-label">Cửa hàng</label>
        <BDropdownCustom
          v-model="local.storeIds"
          :options="storeDropdownOptions"
          placeholder="cửa hàng"
          :searchable="true"
          :matchKey="['name', 'shortName']"
          :limit="10"
          :compareById="true"
        />
      </b-col>

      <b-col
        v-if="showStoreA"
        md="6"
        lg="2"
        class="mb-2"
      >
        <label class="filter-label">CH A</label>
        <b-form-select
          v-model="local.storeIdA"
          class="select-style"
          size="sm"
          :options="storeSelectOptions"
        />
      </b-col>
      <b-col
        v-if="showStoreB"
        md="6"
        lg="2"
        class="mb-2"
      >
        <label class="filter-label">CH B</label>
        <b-form-select
          v-model="local.storeIdB"
          class="select-style"
          size="sm"
          :options="storeSelectOptions"
        />
      </b-col>

      <b-col
        v-if="showSearch"
        md="6"
        :lg="searchColSize"
        class="mb-2"
      >
        <label class="filter-label">Tìm kiếm</label>
        <b-input-group size="sm">
          <b-input-group-prepend is-text>
            <i class="fas fa-search text-muted" />
          </b-input-group-prepend>
          <b-form-input
            v-model="local.searchText"
            :placeholder="searchPlaceholder"
            @keyup.enter="apply"
          />
        </b-input-group>
      </b-col>

      <b-col
        v-if="showBillType"
        md="6"
        lg="2"
        class="mb-2"
      >
        <label class="filter-label">Loại HĐ</label>
        <b-form-select
          v-model="local.billType"
          class="select-style"
          size="sm"
          :options="billTypeOptions"
        />
      </b-col>

      <b-col
        cols="12"
        lg="auto"
        class="mb-2 d-flex"
      >
        <b-button
          variant="primary"
          size="sm"
          class="btn-apply mr-2"
          :disabled="loading"
          @click="apply"
        >
          Áp dụng
        </b-button>
        <b-button
          v-if="showDateRange"
          variant="outline-secondary"
          size="sm"
          class="mr-2"
          :disabled="loading"
          @click="clearDateRange"
        >
          Bỏ lọc ngày
        </b-button>
        <b-button
          variant="link"
          size="sm"
          class="text-muted px-0"
          :disabled="loading"
          @click="reset"
        >
          Đặt lại
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue';
import { DP_CONFIG } from '@/utils/date';
import { BILL_TYPE_OPTIONS } from '../constants';

export default {
  name: 'SalesReportsInlineFilter',
  components: { BDropdownCustom },
  props: {
    filters: { type: Object, required: true },
    stores: { type: Array, default: () => [] },
    tabKey: { type: String, default: '' },
    filterFields: { type: Array, default: () => [] },
    searchPlaceholder: { type: String, default: 'Tìm kiếm...' },
    hideDateFilter: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      dpConfigs: DP_CONFIG,
      local: { ...this.filters },
      billTypeOptions: BILL_TYPE_OPTIONS,
    };
  },
  computed: {
    showDateRange() {
      return !this.hideDateFilter && this.hasField('date');
    },
    showStoreMulti() {
      return this.hasField('store');
    },
    showStoreA() {
      return this.hasField('storeA');
    },
    showStoreB() {
      return this.hasField('storeB');
    },
    showSearch() {
      return this.hasField('search');
    },
    showBillType() {
      return this.hasField('billType');
    },
    searchColSize() {
      if (!this.showDateRange && !this.showStoreMulti) {
        return 6;
      }
      return 3;
    },
    storeDropdownOptions() {
      return this.stores.map((store) => ({
        id: store.id,
        name: store.name || store.shortName,
        shortName: store.shortName,
      }));
    },
    storeSelectOptions() {
      return this.stores.map((store) => ({
        value: store.id,
        text: store.shortName || store.name,
      }));
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(value) {
        this.local = { ...value };
      },
    },
  },
  methods: {
    hasField(name) {
      return this.filterFields.includes(name);
    },
    apply() {
      this.$emit('apply', { ...this.local });
    },
    clearDateRange() {
      this.local.startDate = '';
      this.local.endDate = '';
      this.apply();
    },
    reset() {
      this.$emit('reset');
    },
  },
};
</script>

<style scoped>
.sales-reports-inline-filter {
  padding: 1rem 1.25rem;
}
.filter-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
}
.lov-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}
.btn-apply {
  border-radius: 8px;
  font-weight: 500;
}
</style>
